/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
export class CandidateReputationEntity extends Entity {
  averageClientRecommendScore: number | null = null;
  businessJudgementScore: number | null = null;
  candidateId: string = '';
  communicationScore: number | null = null;
  createdAt: string | null = null;
  id: string = '';
  legalExpertiseScore: number | null = null;
  numberOfAxiomEngagements: number = 0;
  numberOfEngagements: number = 0;
  numberOfRespondents: number = 0;
  numberOfReviews: number = 0;
  numberOfTestimonials: number = 0;
  percentageOfReEngagements: number | null = null;
  percentMetExpectations: number | null = null;
  reputationSummary: string | null = null;
  responsivenessScore: number | null = null;
  updatedAt: string | null = null;
  yearsAtAxiom: number = 0;
  displayableSurveyScoreData?: boolean | null = null;
  hasEnoughRespondents?: boolean | null = null;
  talentRelatedRollOffs?: number | null = null;
  static override key = 'CandidateReputation';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'CandidateReputation' in input
    ) {
      const { CandidateReputation: wrapped, ...rest } = input as {
        CandidateReputation: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}